export default __webpack_public_path__ + "static/media/skilllane_certificate_logo.c67ca34a.png";